/**
 * @file automatically generated from MApp.Endpoints.LegendController
 */ 

import { MetadataClient } from '../metadataClient';
import { ILegendListItem, ITreeLegendV2, ISaveTreeLegendV2, ITreeLegend, ISaveTreeLegend, ILegend, ISaveLegend, IPostSaveTheme, ISaveTheme, IPostSaveLayer, ISaveLayer, IValidationResult, IBoolObject } from '../models';

export class LegendClient extends MetadataClient {

    public static getAllLegends() {
        return MetadataClient.ajax<ILegendListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/all`)
        );
    }

    public static getAdvancedLegends() {
        return MetadataClient.ajax<ILegendListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/advanced`)
        );
    }

    public static getAdvancedLegend(id: string) {
        return MetadataClient.ajax<ITreeLegendV2>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/advanced/${encodeURIComponent(id)}`)
        );
    }

    public static deleteAdvancedLegend(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/advanced/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static saveAdvancedLegend(legend: ISaveTreeLegendV2) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/advanced`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(legend)
			})
        );
    }

    public static replaceAdvancedLegend(id: string, newLegend: ISaveTreeLegendV2) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/advanced/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(newLegend)
			})
        );
    }

    public static getDesktopLegends() {
        return MetadataClient.ajax<ILegendListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/legends/desktop`)
        );
    }

    public static getDesktopLegend(id: string) {
        return MetadataClient.ajax<ITreeLegendV2>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/legends/desktop/${encodeURIComponent(id)}`)
        );
    }

    public static getDesktopLegendsLegacy() {
        return MetadataClient.ajax<ILegendListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/desktop`)
        );
    }

    public static getDesktopLegendLegacy(id: string) {
        return MetadataClient.ajax<ITreeLegend>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/desktop/${encodeURIComponent(id)}`)
        );
    }

    public static deleteDesktopLegend(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/desktop/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static saveDesktopLegend(legend: ISaveTreeLegend) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/desktop`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(legend)
			})
        );
    }

    public static replaceDesktopLegend(id: string, newLegend: ISaveTreeLegend) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/desktop/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(newLegend)
			})
        );
    }

    public static getBrowserLegends() {
        return MetadataClient.ajax<ILegendListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/legends/browser`)
        );
    }

    public static getBrowserLegend(id: string) {
        return MetadataClient.ajax<ITreeLegendV2>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/legends/browser/${encodeURIComponent(id)}`)
        );
    }

    public static getBrowserLegendsLegacy() {
        return MetadataClient.ajax<ILegendListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/browser`)
        );
    }

    public static getBrowserLegendLegacy(id: string) {
        return MetadataClient.ajax<ILegend>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/browser/${encodeURIComponent(id)}`)
        );
    }

    public static deleteBrowserLegend(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/browser/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static saveBrowserLegend(legend: ISaveLegend) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/browser`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(legend)
			})
        );
    }

    public static replaceBrowserLegend(id: string, newLegend: ISaveLegend) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/legends/browser/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(newLegend)
			})
        );
    }

    public static saveTreeLegend(legend: ISaveTreeLegend) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/treelegends`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(legend)
			})
        );
    }

    public static getTreeLegend(id: string) {
        return MetadataClient.ajax<ITreeLegend>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/treelegends/${encodeURIComponent(id)}`)
        );
    }

    public static deleteLegend(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/legends/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getTreeLegends() {
        return MetadataClient.ajax<ILegendListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/treelegends`)
        );
    }

    public static saveTheme(legendId: string, theme: IPostSaveTheme) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/themes/${encodeURIComponent(legendId)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(theme)
			})
        );
    }

    public static updateTheme(id: string, theme: ISaveTheme) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/themes/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(theme)
			})
        );
    }

    public static deleteTheme(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/themes/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static reorderThemes(themeIds: string[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/themes/reorder`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(themeIds)
			})
        );
    }

    public static saveTreeLegendLayer(themeId: string, layer: IPostSaveLayer) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/treelegends/${encodeURIComponent(themeId)}/layers`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(layer)
			})
        );
    }

    public static updateLayer(id: string, layer: ISaveLayer) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/layers/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(layer)
			})
        );
    }

    public static deleteTreeLegendLayer(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/treelegends/layers/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static reorderTreeLegendLayers(layerIds: string[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/treelegends/layers/reorder`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(layerIds)
			})
        );
    }

    public static isValidLegend(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/legends/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static isValidTheme(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/themes/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static saveLegend(legend: ISaveLegend) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/legends`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(legend)
			})
        );
    }

    public static saveLegendLayer(legendId: string, layer: IPostSaveLayer) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/legends/${encodeURIComponent(legendId)}/layers`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(layer)
			})
        );
    }

    public static deleteLegendLayer(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/legends/layers/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static reorderLegendLayers(layerIds: string[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/legends/layers/reorder`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(layerIds)
			})
        );
    }

    public static getLegend(id: string) {
        return MetadataClient.ajax<ILegend>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/legends/${encodeURIComponent(id)}`)
        );
    }

    public static getLegends() {
        return MetadataClient.ajax<ILegendListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/legends`)
        );
    }

    public static hasAdvancedLegendVector(id: string) {
        return MetadataClient.ajax<IBoolObject>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/legends/${encodeURIComponent(id)}/hasvector`)
        );
    }

    public static hasTreeLegendVector(id: string) {
        return MetadataClient.ajax<IBoolObject>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/treelegends/${encodeURIComponent(id)}/hasvector`)
        );
    }

    public static hasLegendVector(id: string) {
        return MetadataClient.ajax<IBoolObject>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/legends/${encodeURIComponent(id)}/hasvector`)
        );
    }
}
